import axios from '../../../../../redux/my-axios';

export const STOCKS_URL = '/stocks';

// READ
export function findStocks(queryParams) {
  //console.log(queryParams);
  return axios.post(STOCKS_URL, queryParams, { headers: { action: 'find' } });
}

export function getStock(stockCode) {
  return axios.post(STOCKS_URL, stockCode, { headers: { action: 'get' } });
}

export function createStock(stockForCreate) {
  return axios.post(STOCKS_URL, stockForCreate, {
    headers: { action: 'post' },
  });
}

export function updateStock(stockForView) {
  return axios.post(STOCKS_URL, stockForView, {
    headers: { action: 'put' },
  });
}

export function deleteStock(stockCode) {
  return axios.post(STOCKS_URL, stockCode, {
    headers: { action: 'delete' },
  });
}
